/* Copied from github.com/springload/react-iframe-click/blob/master/src/index.tsx
 *
 * Tweaked a bit:
 *   - removed onInferredClick from props to avoid console warnings
 *   - fixed IframeProps type to use correct IframeHTMLAttributes
 */
import React, { useEffect, useRef, useCallback } from 'react';

interface IframeProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
  onInferredClick: (iframe: HTMLIFrameElement) => void;
}

export default function Iframe({
  onInferredClick,
  title,
  ...props
}: IframeProps) {
  const iframeRef = useRef<null | HTMLIFrameElement>(null);

  const iframeCallbackRef = useCallback(
    (node: null | HTMLIFrameElement): void => {
      iframeRef.current = node;
    },
    [],
  );

  useEffect(() => {
    const onBlur = () => {
      if (
        document.activeElement &&
        document.activeElement.nodeName.toLowerCase() === 'iframe' &&
        iframeRef.current &&
        iframeRef.current === document.activeElement
      ) {
        onInferredClick(iframeRef.current);
      }
    };

    window.addEventListener('blur', onBlur);

    return () => {
      window.removeEventListener('blur', onBlur);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <iframe title={title} {...props} ref={iframeCallbackRef} />;
}
